import { Link, Text } from "@certn/cascadia-react";
import { Trans } from "react-i18next";

export function HelpPrivacyConsent() {
  return (
    <Trans>
      <Text color="text-weak">
        By clicking 'Submit', you agree to be contacted by Certn for the
        purposes of providing further information. You can withdraw your consent
        at any time by contacting Certn’s Privacy Officer at +1 (844) 987-0690
        or{" "}
        <Link
          testID="dispute-report-modal-contact-email"
          target="_blank"
          textStyle="global/body-secondary"
          textColor="text-weak"
          href="mailto: privacy@certn.co"
        >
          privacy@certn.co
        </Link>
        . Further information regarding the collection, use, disclosure, or
        storage of your Personal Information can be found in our{" "}
        <Link
          testID="dispute-report-modal-contact-email"
          target="_blank"
          textStyle="global/body-secondary"
          textColor="text-weak"
          href="https://certn.co/privacy-policy/"
        >
          Privacy Policy
        </Link>
        .
      </Text>
    </Trans>
  );
}
